import {UntypedFormControl} from '@angular/forms'

export function NoWhitespaceValidator(control: UntypedFormControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : {'whitespace': true};
}
